import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12" data-id="element-124">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-125">
        <h3 className="text-2xl font-bold mb-2" data-id="element-126">Stressless Dogs</h3>
        <p className="text-gray-400 italic mb-8" data-id="element-127">
          Natuurlijk, stressvrij en met liefde
        </p>

        <div className="max-w-2xl mx-auto border-t border-gray-800 pt-8" data-id="element-128">
          <h4 className="font-bold text-gray-500 text-sm uppercase tracking-wider mb-4" data-id="element-129">
            Disclaimer
          </h4>
          <p className="text-gray-500 text-sm leading-relaxed" data-id="element-130">
            Stressless Dogs is een onafhankelijke partner van Anifit.
            Bestellingen worden geplaatst en afgehandeld door Anifit. Voor
            product- en leveringsvragen kun je terecht bij de Anifit
            klantenservice of bij ons team voor voedingsadvies.
          </p>
        </div>

        <div className="mt-8 text-gray-600 text-xs" data-id="element-131">
          &copy; {new Date().getFullYear()} Stressless Dogs. Alle rechten
          voorbehouden.
        </div>
      </div>
    </footer>;
}